import React from 'react';
import { Container, Box, Typography, Divider } from '@mui/material';

function TermsOfService() {
  const primaryColor = '#800000';

  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      {/* Header with Logo and Title */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
        <Box
          component="img"
          src="/create.png" // If logo is in public folder; otherwise adjust path
          alt="Company Logo"
          sx={{ width: 200, height: 'auto' }}
        />
        <Typography
          variant="h4"
          component="h1"
          sx={{ color: primaryColor, fontWeight: 600 }}
        >
          Terms of Use
        </Typography>
      </Box>

      <Divider sx={{ borderColor: primaryColor, mb: 3 }} />

      <Typography variant="body2" color="text.secondary" paragraph>
        {/* Last updated: [Date] */}
      </Typography>

      <Typography paragraph>
        This Website is the official Campus for Research Excellence And Technological Enterprise website.  It is owned and operated by the Campus for Research Excellence And Technological Enterprise (hereinafter “CREATE”).  CREATE reserves the right to update or modify this Website from time to time.
      </Typography>

      <Typography variant="h6" sx={{ color: primaryColor, mt: 3, fontWeight: 600 }}>
        Agreement - Terms
      </Typography>
      <Typography paragraph>
       Thank you for visiting the CREATE website (“The Website”). All access of any area of The Website is governed by the terms and conditions below (“Terms”). If you do not accept any of these Terms, please do not continue using The Website.
      </Typography>
      <Typography paragraph>
       In these Terms, the words “we”, “our” and “us” refers to the Government of Singapore
      </Typography>

      <Typography variant="h6" sx={{ color: primaryColor, mt: 3, fontWeight: 600 }}>
        Access To The Website
      </Typography>
      <Typography paragraph>
        The accessibility and operation of The Website relies on technologies outside our control. We do not guarantee continuous accessibility or uninterrupted operation of The Website.
      </Typography>


      <Typography variant="h6" sx={{ color: primaryColor, mt: 3, fontWeight: 600 }}>
        Relying on Information
      </Typography>
      <Typography paragraph>
        We provide The Website as a general information source only. We do not guarantee the timeliness, accuracy, completeness or reliability of any statements, opinion, representation or other information in The Website. You should do your own checks. Before relying on The Website, you should do your own checks or obtain professional advice relevant to your particular circumstances.
      </Typography>


      <Typography variant="h6" sx={{ color: primaryColor, mt: 3, fontWeight: 600 }}>
        Security
      </Typography>
      <Typography paragraph>
        Where appropriate, we use available technology to protect the security of communications made through The Website. However, we do not accept liability for the security, authenticity, integrity or confidentiality of any transactions and other communications made through The Website.
      </Typography>

      <Typography variant="h6" sx={{ color: primaryColor, mt: 3, fontWeight: 600 }}>
        Hyperlinks
      </Typography>
      <Typography paragraph>
        We are not responsible or liable for the availability or content of any other Internet site (not provided by us) linked to or from The Website. Access to any other Internet sites is at your own risk. If you create a link or frame to The Website, you do so at your own risk. We reserve the right to object or disable any link or frame to or from The Website.
      </Typography>

      <Typography variant="h6" sx={{ color: primaryColor, mt: 3, fontWeight: 600 }}>
        Intellectual Property
      </Typography>
      <Typography paragraph>
        Materials, including design, source codes, pages, documents and online graphics, audio and video in The Website are protected by law. The intellectual property rights in the materials are owned or licensed to us. No part of The Website may be reproduced or reused for any commercial purposes whatsoever without our prior written permission. The modification of the materials on The Website is prohibited.
      </Typography>

      {/* <Typography variant="h6" sx={{ color: primaryColor, mt: 3, fontWeight: 600 }}>
        3. Contact Us
      </Typography>
      <Typography paragraph>
        If you have questions about these Terms, please contact us at{' '}
        <Box
          component="a"
          href="mailto:support@example.com"
          sx={{ color: primaryColor, textDecoration: 'none' }}
        >
          support@example.com
        </Box>
        .
      </Typography> */}

      {/* Add more sections as needed */}
    </Container>
  );
}

export default TermsOfService;